export { VpUpgradePromptBox } from './VpUpgradePromptBox';



// WEBPACK FOOTER //
// ./src/vp-ui/components/VpUpgradePromptBox/index.js